import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const DisputeSheet = ({ open, onClose, onConfirm, teamNameA, teamNameB, currentServer }) => {
  const [newServer, setNewServer] = useState(currentServer || 'A');

  const handleConfirm = () => {
    onConfirm({ newServer });
    onClose();
  };

  const TeamBtn = ({ team, name, color }) => (
    <button onClick={() => setNewServer(team)}
      className="flex-1 flex flex-col items-center gap-2 py-4 rounded-2xl border transition-all active:scale-95"
      style={{
        backgroundColor: newServer === team ? `${color}20` : 'rgba(255,255,255,0.05)',
        borderColor: newServer === team ? `${color}60` : 'rgba(255,255,255,0.1)',
      }}>
      <div className="w-8 h-8 rounded-full flex items-center justify-center font-black text-sm"
        style={{ backgroundColor: newServer === team ? `${color}30` : 'rgba(255,255,255,0.1)', color: newServer === team ? color : 'rgba(255,255,255,0.4)' }}>
        {team}
      </div>
      <span className="text-xs font-black truncate max-w-[6rem]"
        style={{ color: newServer === team ? color : 'rgba(255,255,255,0.4)' }}>
        {name}
      </span>
      {newServer === team && <span className="text-[9px] font-black" style={{ color }}>✓ 發球</span>}
    </button>
  );

  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[175] flex items-end justify-center">
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="absolute inset-0 bg-slate-950/80 backdrop-blur-sm" onClick={onClose} />
          <motion.div
            initial={{ y: '100%' }} animate={{ y: 0 }} exit={{ y: '100%' }}
            transition={{ type: 'spring', damping: 28, stiffness: 320 }}
            className="relative z-10 w-full max-w-lg bg-[#0d1a2e] border-t border-white/10 rounded-t-3xl px-4 pt-4"
            style={{ paddingBottom: 'max(1.5rem, env(safe-area-inset-bottom))' }}
          >
            <div className="w-10 h-1 rounded-full bg-white/20 mx-auto mb-5" />
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-2xl bg-purple-500/20 border border-purple-500/30 flex items-center justify-center text-xl shrink-0">⚖️</div>
              <div>
                <h3 className="text-sm font-black text-white">裁判改判</h3>
                <p className="text-xs text-white/40 font-bold">上一分已撤銷，請選擇正確發球員</p>
              </div>
            </div>

            <p className="text-xs font-black text-white/50 uppercase tracking-widest mb-3">由哪方發球？</p>
            <div className="flex gap-3 mb-5">
              <TeamBtn team="A" name={teamNameA} color="#818cf8" />
              <TeamBtn team="B" name={teamNameB} color="#fb7185" />
            </div>

            <div className="p-3 rounded-xl bg-purple-500/10 border border-purple-500/20 mb-4">
              <p className="text-xs text-purple-300/70 font-bold">
                ℹ️ 確認後系統將記錄改判事件，並以新選擇的發球員繼續比賽。
              </p>
            </div>

            <div className="flex gap-2.5">
              <button onClick={onClose}
                className="flex-1 py-3.5 rounded-2xl bg-white/5 border border-white/10 text-white/40 font-black text-sm hover:bg-white/10 transition-all">
                取消
              </button>
              <button onClick={handleConfirm}
                className="flex-1 py-3.5 rounded-2xl bg-purple-500 hover:bg-purple-400 text-white font-black text-sm transition-all active:scale-95">
                確認改判
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default DisputeSheet;